var _path, _g, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect2, _path13, _g2, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 216,
    height: 166,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194 18H22a4 4 0 0 0-4 4v20h180V22a4 4 0 0 0-4-4z",
    fill: "#E8E9EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194 18H22a4 4 0 0 0-4 4v122a4 4 0 0 0 4 4h172a4 4 0 0 0 4-4V22a4 4 0 0 0-4-4z",
    fill: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 25,
    width: 78,
    height: 60,
    rx: 4,
    fill: "#E4DEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.821 51.75h9.777v2.683h-9.777V51.75zm35.791 11.624c-1.005.528-4.074-.397-5.096-.707-2.305-.695-6.845-2.513-6.798-4.275.033-1.249 2.362-2.099 4.654-1.793 4.602.612 8.973 5.864 7.24 6.774v.001zm-61.224-.05c1.005.528 4.074-.397 5.096-.707 2.305-.695 6.845-2.513 6.798-4.275-.033-1.249-2.362-2.099-4.654-1.793-4.602.612-8.973 5.863-7.24 6.774v.001z",
    fill: "#0C5132"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.73 46.606s3.372 4.047 3.763 4.173c.391.125 2.983.236 3.259.503.13.126.165 1.392.075 2.24a.717.717 0 0 1-.697.63c-.524.018-1.262.101-1.725.4-.782.502-2.057 3.183-2.057 3.183",
    fill: "#136F45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.379 53.986c0 5.522 4.639 9.998 10.363 9.998 5.724 0 10.363-4.476 10.363-9.998 0-5.521-4.64-9.997-10.363-9.997-3.355 0-6.338 1.538-8.232 3.922a9.731 9.731 0 0 0-2.131 6.075z",
    fill: "#136F45"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.372 47.636s-2.13 2.877-2.982 2.74c-.853-.137-2.414-1.369-4.969-1.095l.142 2.603s2.306-.484 3.265 1.918c1.155 2.89 2.293 4.09 2.719 4.776",
    fill: "#136F45"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.489 53.873c0 4.127-3.504 7.472-7.826 7.472-4.323 0-7.827-3.345-7.827-7.472 0-4.127 3.504-7.472 7.827-7.472 2.534 0 4.786 1.15 6.216 2.932a7.225 7.225 0 0 1 1.61 4.54z",
    fill: "#2E2E2F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.51 46.602s-3.372 4.047-3.763 4.173c-.391.126-2.983.236-3.259.503-.13.126-.166 1.392-.076 2.24a.718.718 0 0 0 .698.63c.524.018 1.262.101 1.724.4.783.502 2.057 3.183 2.057 3.183",
    fill: "#136F45"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.863 53.98c0 5.523-4.64 9.998-10.364 9.998-5.724 0-10.363-4.475-10.363-9.997s4.639-9.997 10.363-9.997c3.356 0 6.338 1.538 8.232 3.922a9.726 9.726 0 0 1 2.132 6.075z",
    fill: "#136F45"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M146.863 53.98c0 5.523-4.64 9.998-10.364 9.998-5.724 0-10.363-4.475-10.363-9.997s4.639-9.997 10.363-9.997c3.356 0 6.338 1.538 8.232 3.922a9.726 9.726 0 0 1 2.132 6.075z",
    fill: "#136F45"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.866 47.63s2.13 2.878 2.981 2.74c.851-.136 2.414-1.369 4.971-1.095l-.143 2.603s-2.306-.484-3.265 1.918c-1.155 2.89-2.293 4.09-2.719 4.776",
    fill: "#136F45"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.253 53.873c0 4.127-3.503 7.472-7.826 7.472-4.323 0-7.826-3.345-7.826-7.472s3.503-7.472 7.826-7.472c2.534 0 4.786 1.15 6.217 2.932a7.224 7.224 0 0 1 1.609 4.54z",
    fill: "#2E2E2F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26 29a4 4 0 0 1 4-4h70a4 4 0 0 1 4 4v95a4 4 0 0 1-4 4H30a4 4 0 0 1-4-4V29z",
    fill: "#E0F0FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 93,
    width: 78,
    height: 48,
    rx: 4,
    fill: "#FEDAD9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.377 68.613s-.07-.375-.491-.781C93.608 61.779 88.79 56.973 85.28 55.304c-3.465-1.65-3.536-.035-7.91-1.704-.103-.04-.152-.073-.168-.03v.004c.005.125.01.251.01.378.015 4.697-3.185 8.656-7.537 9.807h-.002a10.204 10.204 0 0 1-2.575.337 10.144 10.144 0 0 1-7.669-3.451c-.772-.766-.947-1.185-1.018-1.377l-.08-.134c-.065-.006-.387-.538-.707-1.436a10.053 10.053 0 0 1-.707-3.681 9.782 9.782 0 0 1 .006-.352v-.014l.003-.06c.01-.25.028-.495.055-.74v-.018c-4.43 1.683-5.45.268-8.904 1.906-3.498 1.659-7.728 5.84-13.966 11.813-.418.4-.935.774-1.043 1.329-.116.599.233 1.18.57 1.697l6.669 10.267a.365.365 0 0 0 .452.135l6.466-2.76a.366.366 0 0 1 .51.347 501.247 501.247 0 0 0-.32 33.74c.18.067.093.027.18.067 15.507 7.039 37.838 1.404 37.838 1.404.036 0 .896-.215.902-.676a522.611 522.611 0 0 0-.56-33.522.364.364 0 0 1 .51-.347l6.477 2.77c.166.071.36.012.456-.14l6.601-10.515c.332-.53.677-1.125.557-1.735z",
    fill: "#F3F3F3",
    stroke: "#CCC",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6 6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.965 55.286s-.077-.412-.539-.858c-6.891-6.644-12.179-11.918-16.031-13.751-3.804-1.81-3.881-.038-8.682-1.87-.114-.044-.168-.08-.185-.032v.003c.005.137.01.276.01.415.018 5.155-3.495 9.502-8.272 10.764h-.003c-.902.239-1.85.368-2.827.37a11.133 11.133 0 0 1-8.417-3.788c-.847-.84-1.04-1.3-1.118-1.511l-.088-.147c-.07-.007-.424-.59-.776-1.576a11.036 11.036 0 0 1-.775-4.04 11.002 11.002 0 0 1 .007-.387v-.015c0-.01 0-.034.003-.066.01-.274.03-.544.06-.813v-.02c-4.862 1.848-5.982.295-9.774 2.093-3.84 1.82-8.483 6.41-15.33 12.967-.459.44-1.026.849-1.145 1.458-.127.658.256 1.296.626 1.864l7.32 11.269a.403.403 0 0 0 .497.149l7.097-3.03a.4.4 0 0 1 .56.38 550.197 550.197 0 0 0-.356 36.824.326.326 0 0 0 .202.285c17.022 7.726 41.534 1.541 41.534 1.541.039 0 .983-.236.99-.741a573.607 573.607 0 0 0-.615-36.796.399.399 0 0 1 .559-.381l7.111 3.04a.405.405 0 0 0 .5-.154l7.246-11.542c.364-.582.743-1.235.611-1.904z",
    fill: "#0094D5"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m64.96 39.121 10.673 1.89 10.66-1.958-1.028 7.297-9.607 2.142-7.157-2.089-3.541-7.282z",
    fill: "#3B69B7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.052 40.382c.031 1.258-.028 1.707.003 2.966 3.571-.275 6.398-1.284 9.163-3.52-.256-.595 1.294-.849-.453-2.626-2.626 1.905-5.558 3.17-8.713 3.18z",
    fill: "#002E6A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.364 40.357c-.023 1.257-.287 1.724-.31 2.982-4.84.346-6.962-1.09-9.741-3.31.252-.595.165-2.348.598-2.92 2.64 1.888 5.817 3.403 9.453 3.256v-.008z",
    fill: "#002E6A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.81 37.699c-.893-.19-2.149-.274-3.042-.464.449 2.754-.466 5.693-2.408 7.729-1.943 2.036-4.776 2.81-7.604 2.549.04.828-.014 1.973.025 2.801 3.546.171 7.241-.851 9.83-3.239 2.587-2.387 3.742-6.045 3.2-9.376h-.001z",
    fill: "#005BD3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.871 37.612c.892-.195 2.147-.288 3.04-.483-.431 2.757.503 5.69 2.459 7.713 1.954 2.024 4.714 2.953 7.54 2.675-.033.828.11 1.931.077 2.76-4.113.405-7.25-.938-9.854-3.31-2.604-2.37-3.783-6.022-3.261-9.357v.002z",
    fill: "#005BD3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m138.132 110.807-4.723 7.846-.55.916L127 116.92v-7.875c0-.777.721-1.251 1.303-.869 3.539 2.325 6.808 3.156 9.829 2.631z",
    fill: "#EF4D2F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M150.261 111.114 142.6 123.97l-9.741-4.401.55-.916 4.723-7.846c1.907-.332 3.714-1.199 5.426-2.578l6.703 2.885z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M142.6 123.971H127v-7.05l5.854 2.649h.005l9.741 4.401z",
    fill: "#E8E9EB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m155.084 113.194-6.417 10.777h-2.6l6.747-11.759 2.27.982zm14.469 10.52c-.061.015-.121.03-.182.035-.724.151-1.46.222-2.197.222h-15.041l5.543-9.664 6.17 2.654c1.846.796 3.41 2.301 4.424 4.265l1.283 2.488z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M179 119.726v.381l-7.38 2.952c-.733.312-1.482.54-2.246.692l-.003-.002-1.1-2.523c-1.014-1.963-2.579-3.469-4.425-4.265l-6.17-2.654-.247-.105-2.241-.962-.104-.046-2.27-.982-.122-.05-2.236-.962-.195-.085-6.703-2.886c1.001-.8 1.964-1.771 2.904-2.911.238-.289.599-.395.923-.259l30.475 12.773c.685.292 1.14 1.048 1.14 1.894z",
    fill: "#E8E9EB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m152.814 112.212-6.747 11.759H142.6l7.661-12.856.195.085 2.236.962.122.05zm4.862 2.095-5.543 9.663h-3.466l6.417-10.776.104.045 2.241.962.247.106z",
    fill: "#D4CCFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M179 120.108v2.499c0 .826-.433 1.566-1.088 1.873l-5.256 2.437a11.4 11.4 0 0 1-4.827 1.083h-39.962c-.479 0-.867-.451-.867-1.007v-3.052l40.174.03c.737 0 1.474-.07 2.197-.221.061-.005.122-.02.182-.035a11.423 11.423 0 0 0 2.067-.655l7.38-2.952z",
    fill: "#00527C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M151 108.569c0 .657-.448 1.19-1 1.19s-1-.533-1-1.19c0-.657.448-1.19 1-1.19s1 .533 1 1.19zm4 1.586c0 .657-.448 1.19-1 1.19s-1-.533-1-1.19c0-.657.448-1.189 1-1.189s1 .532 1 1.189zm4 1.586c0 .657-.448 1.19-1 1.19s-1-.533-1-1.19c0-.657.448-1.189 1-1.189s1 .532 1 1.189zm4 1.587c0 .657-.448 1.189-1 1.189s-1-.532-1-1.189.448-1.19 1-1.19 1 .533 1 1.19z",
    fill: "#9FA5AB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26 140a4 4 0 0 1 4-4h70a4 4 0 0 1 4 4v8H26v-8z",
    fill: "#EBEBEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 6.07,
    y: 7.626,
    width: 203.86,
    height: 153.86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.556
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.965
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_232_11566"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.037
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.778
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_232_11566",
    result: "effect2_dropShadow_232_11566"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_232_11566",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 27.128,
    y: 27.591,
    width: 97.793,
    height: 92.003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.556
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.965
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_232_11566"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.037
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.778
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_232_11566",
    result: "effect2_dropShadow_232_11566"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_232_11566",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPlaceholder);
export default __webpack_public_path__ + "static/media/product_placeholder.33031985ec75fac35d18049eb8aa2377.svg";
export { ForwardRef as ReactComponent };